import { ComplianceRequirement } from '../types/compliance';

export const sampleRequirements: ComplianceRequirement[] = [
  {
    id: '1',
    title: 'HSR Filing',
    description: 'Submit Hart-Scott-Rodino antitrust filing for regulatory approval',
    category: 'antitrust',
    status: 'in_progress',
    priority: 'high',
    dueDate: '2024-04-15',
    assignee: 'Sarah Johnson',
    jurisdiction: 'United States',
    documents: ['HSR Form.pdf', 'Supporting Documents.zip'],
    notes: 'Initial draft completed, pending review by legal team',
    createdAt: '2024-03-01',
    updatedAt: '2024-03-10'
  },
  {
    id: '2',
    title: 'Financial Statement Audit',
    description: 'Complete audit of target company financial statements',
    category: 'financial',
    status: 'pending',
    priority: 'high',
    dueDate: '2024-04-30',
    assignee: 'Michael Chen',
    documents: ['Audit Plan.pdf'],
    notes: 'Coordinating with external auditors',
    createdAt: '2024-03-05',
    updatedAt: '2024-03-05'
  },
  {
    id: '3',
    title: 'Employment Agreements Review',
    description: 'Review and update key employee agreements',
    category: 'legal',
    status: 'completed',
    priority: 'medium',
    dueDate: '2024-03-31',
    assignee: 'David Wilson',
    documents: ['Employment Contracts.pdf'],
    notes: 'All key agreements reviewed and updated',
    createdAt: '2024-02-15',
    updatedAt: '2024-03-31'
  },
  {
    id: '4',
    title: 'SEC Filing Requirements',
    description: 'Prepare and submit required SEC filings',
    category: 'regulatory',
    status: 'pending',
    priority: 'high',
    dueDate: '2024-05-15',
    assignee: 'Emily Brown',
    jurisdiction: 'United States',
    documents: ['SEC Forms.pdf'],
    notes: 'Initial documentation gathering in progress',
    createdAt: '2024-03-10',
    updatedAt: '2024-03-10'
  },
  {
    id: '5',
    title: 'Environmental Compliance Review',
    description: 'Assess environmental compliance and permits',
    category: 'regulatory',
    status: 'in_progress',
    priority: 'medium',
    dueDate: '2024-04-20',
    assignee: 'Robert Taylor',
    jurisdiction: 'Multiple States',
    documents: ['Environmental Assessment.pdf'],
    notes: 'Site visits scheduled for next week',
    createdAt: '2024-03-01',
    updatedAt: '2024-03-15'
  }
];